<!--
 * Created by JackCui on 2021/9/27
 -->
<template>
  <el-form
    :class="`sy-form sy-form-${computedPosition}`"
    v-bind="{...$props, ...$attrs}"
    :labelPosition="computedPosition"
    :label-width="labelWidth"
    :span='defaultSpan'
    v-on="$listeners"
    @submit.native.prevent
    ref="form"
  >
    <slot/>
  </el-form>
</template>

<script>
  import {FORM_POSITION_SPAN} from './static'
  export default {
    name: 'sy-form',
    props: {
      model: {
        type: Object,
        default: () => {
          return {}
        }
      },
      // 整体几列
      span: {
        type: [String],
        default: 'auto'
      },
      // label位置
      labelPosition: {
        type: [String],
        default: ''
      },
      // label宽度
      labelWidth: {
        type: [String],
        default: '110px'
      },
      // 整体样式类型
      styleType: {
        type: [String],
        default: 'small'
      },
      // 是否隐藏label
      hideLabel: {
        type: Boolean,
        default: undefined
      },
      // 是否跟随
      follow: {
        type: Boolean,
        default: undefined
      },
      // 内容区是否为文本
      isText: {
        type: Boolean,
        default: undefined
      },
      // 页面类型 plain 一般   popup 弹窗
      pageType: {
        type: String
      }
    },
    data () {
      return {
        apiPosition: 'right'
      }
    },
    computed: {
      getRef () {
        return this.$refs['form']
      },
      computedPosition () {
        return this.labelPosition || this.apiPosition
      },
      defaultSpan () {
        const defaultSpan = FORM_POSITION_SPAN[this.computedPosition]
        return [this.span, defaultSpan].find(v => (v === 0 || (v && v !== 'auto')))
      }
    },
    provide () {
      return {
        syForm: this
      }
    },
    async created () {
      if (!(this.follow || this.labelPosition)) {
        await this.getLabelPosition()
      }
    },
    methods: {
      async getLabelPosition () {
        this.apiPosition = await this.$CatchStore?.getInterfaceData('getType').getter()
      },
      validate (fun) {
        return this.$refs['form'].validate(fun)
      },
      validateField (props, fun) {
        return this.$refs['form'].validateField(props, fun)
      },
      resetFields () {
        return this.$refs['form'].resetFields()
      },
      clearValidate (props) {
        return this.$refs['form'].clearValidate(props)
      }
    }
  }
</script>

<style scoped lang="scss">
  .sy-form {
    // font-size: 0;
  }
  
  .sy-form-top {
    ::v-deep .el-form-item__label {
      font-size: 14px;
      color: #636E95;
      letter-spacing: 0;
      line-height: 26px;
      font-weight: 400;
      padding-bottom: 8px;
    }

    ::v-deep .el-form-item__error {
      position: static;
      padding-bottom: 2px;
    }
  }

  .sy-form-right, .sy-form-left {
    ::v-deep .el-form-item__label {
      font-size: 14px;
      color: #636E95;
      letter-spacing: 0;
      font-weight: 400;
      padding-top: 8px;
      padding-bottom: 0;
      line-height: 20px;
    }

    ::v-deep .el-form-item__error {
      top: auto;
      position: static;
      padding-bottom: 2px;
    }
  }
</style>
